import { CustomerData } from "./types";

/**
 * Builds the customerData payload sent to the submitFormFunnelLead mutation.
 * Extracted from ConfirmStep for testability.
 */
export function buildCustomerData(data: CustomerData) {
  return {
    firstName: data.nameFirst,
    lastName: data.nameLast,
    email: data.email,
    phone: data.phone,
    address: data.address,
    zipCode: data.address?.zip,
    dob: data.dob,
    educationLevel: data.educationLevel,
  };
}
